<template>
  <section class="contact">
    <TheHeader />
    <div class="contact__grid">
      <div class="contact__grid__colum1">
        <img src="@/assets/contato.png" alt class="img--desk" />
        <img src="@/assets/contato-m.png" alt class="img--mobile" />
        <div class="contact__grid__colum1__text">
          <h1>ENTRE EM CONTATO</h1>
          <p>
            <strong>Central de Vendas:</strong>
            <a href="tel:08007292076">0800 729 2076</a>
          </p>

          <p>
            <strong>SAC:</strong>
            <a href="tel:08002838916">0800 283 8916</a>
          </p>
        </div>
      </div>
      <div class="contact__grid__colum2">
        <form @submit.prevent="handleSubmit()" class="form">
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.subject.$error }"
          >
            <div class="select">
              <select v-model.trim="$v.field.subject.$model">
                <option :value="null" selected disabled hidden>
                  Selecione o assunto
                </option>
                <option :value="option" v-for="option in options" :key="option">
                  {{ option }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.name.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.name.$model"
              placeholder="*Nome"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.email.$error }"
          >
            <input
              type="email"
              v-model.trim="$v.field.email.$model"
              placeholder="*E-mail"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.cpf.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.cpf.$model"
              placeholder="CPF"
              v-mask="'###.###.###-##'"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.telefone.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.telefone.$model"
              placeholder="Telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
            />
          </div>
          <div
            class="form__group"
            :class="{ 'form__group--error': $v.field.zipcode.$error }"
          >
            <input
              type="text"
              v-model.trim="$v.field.zipcode.$model"
              placeholder="*CEP"
              v-mask="'##.###-###'"
            />
          </div>
          <div class="form__group">
            <textarea
              v-model.trim="field.message"
              cols="30"
              rows="5"
              placeholder="Sua mensagem"
              :class="{ 'form__group--error': $v.field.message.$error }"
            ></textarea>
          </div>
          <div class="contact__erros" v-if="$v.$error">
            <TheAlert v-if="!$v.field.subject.required"
              >Selecione o assunto que você deseja.</TheAlert
            >
            <TheAlert v-if="!$v.field.name.required"
              >Entre com o seu nome.</TheAlert
            >
            <TheAlert v-if="!$v.field.email.required"
              >Entre com o seu email.</TheAlert
            >
            <TheAlert v-if="!$v.field.email.email">E-mail inválido.</TheAlert>
            <TheAlert v-if="!$v.field.cpf.required"
              >Entre com seu CPF.</TheAlert
            >
            <TheAlert v-if="!$v.field.cpf.minLength"
              >Preencha o CPF corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.telefone.required"
              >Entre com o seu telefone.</TheAlert
            >
            <TheAlert v-if="!$v.field.telefone.minLength"
              >Preencha o telefone corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.zipcode.required"
              >Entre com o seu CEP.</TheAlert
            >
            <TheAlert v-if="!$v.field.zipcode.minLength"
              >Preencha o CEP corretamente.</TheAlert
            >
            <TheAlert v-if="!$v.field.message.minLength"
              >Preencha a mensagem corretamente.</TheAlert
            >
          </div>
          <button type="submit" :disabled="loading">
            {{ loading ? 'Enviando...' : 'Enviar' }}
          </button>
        </form>
        <div class="contact__grid__colum2__msg" v-if="send">
          <p>{{ sendMsg }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { required, minLength, email } from 'vuelidate/lib/validators';
import {handleContactSend} from "@/services/gtm";
export default {
  title() {
    return `Contato | Cartão de TODOS Atlético`;
  },
  data() {
    return {
      options: ['Solicitação', 'Reclamação', 'Informação', 'Outros'],
      send: false,
      sendMsg: null,
      loading: false,
      field: {
        page: 'cdtc',
        subject: null,
        name: null,
        email: null,
        cpf: null,
        telefone: null,
        zipcode: null,
        message: null,
      },
    };
  },
  validations: {
    field: {
      subject: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      cpf: {
        required,
        minLength: minLength(14),
      },
      telefone: {
        required,
        minLength: minLength(14),
      },
      zipcode: {
        required,
        minLength: minLength(10),
      },
      message: {
        required,
        minLength: minLength(10),
      },
    },
  },
  components: {
    TheAlert: () => import('@/components/TheAlert.vue'),
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        handleContactSend(
          this.field.subject,
          this.field.zipcode,
          this.field.telefone,
          this.field.email,
          this.field.name,
          this.field.message,
          this.field.cpf
        );
        this.loading = true;
        axios
          .post(
            'https://cartaodetodosatletico.com.br/mail/post.php',
            this.field
          )
          .then((response) => {
            if (!response.data.error) {
              this.sendMsg = 'Sua mensagem foi enviada com sucesso!';
            } else {
              this.sendMsg =
                'Sua mensagem não pode ser enviada no momento, por favor, tente novamente!';
            }
          })
          .finally(() => {
            this.$v.$reset();
            this.send = true;
            this.loading = false;
            this.field.subject = null;
            this.field.name = null;
            this.field.email = null;
            this.field.cpf = null;
            this.field.telefone = null;
            this.field.zipcode = null;
            this.field.message = null;
          });
      }
    },
  },
  created() {
    this.send = false;
  },
};
</script>

<style lang="scss">
.contact {
  margin-top: 68px;
  @include media('>=tablet') {
    margin-top: 105px;
  }
  .img {
    &--desk {
      display: none;
      @include media('>=tablet') {
        display: block;
      }
    }
    &--mobile {
      display: block;
      @include media('>=tablet') {
        display: none;
      }
    }
  }
  .form__group--error {
    select,
    input {
      border: 2px solid $color-black !important;
    }
    &::before {
      content: url('../assets/icons/alert-primary.svg');
    }
  }
  &__erros {
    margin-top: 20px;
  }
  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    margin-top: -2px;
    @include media('>=tablet') {
      grid-template-columns: 44% auto;
    }

    &__colum1 {
      background: $color-black;
      text-align: center;
      padding: 73px 0 43px;
      @include media('>=tablet') {
        background: $color-white;
        padding: 101px 0;
      }

      img,
      &__text {
        display: block;
        margin: initial;
        margin-left: auto;
      }
      img {
        margin-left: auto;
        margin-right: auto;
        @include media('>=tablet') {
          margin-right: 146px;
        }
      }
      &__text {
        text-align: center;
        @include media('>=tablet') {
          width: 270px;
          margin-right: 166px;
          text-align: left;
        }

        h1 {
          font-family: 'Arvo', sans-serif;
          font-weight: 700;
          font-size: 45px;
          color: $color-white;
          margin-top: 40px;
          @include media('>=tablet') {
            margin-top: 90px;
            color: $color-black;
          }
        }

        p {
          font-weight: 700;
          font-size: 20px;
          line-height: 30px;
          color: $color-black;
          margin-top: 25px;
          @include media('<tablet') {
            text-align: left;
            max-width: 174px;
            margin: 25px auto 0;
            color: $color-white;
          }
          a {
            text-decoration: none;
            font-weight: 400;
            color: $color-white;
            display: block;
            margin-top: 5px;
            @include media('>=tablet') {
              color: $color-black;
            }
          }
        }
      }
    }

    &__colum2 {
      background: $color-white;
      padding-top: 50px;
      @include media('>=tablet') {
        background: initial;
      }

      form {
        max-width: 538px;
        padding: 0 35px;
        margin: 0 auto;
        @include media('>=tablet') {
          padding: initial;
          margin-left: 90px;
        }
        select,
        textarea,
        input {
          font-family: 'HelveticaNeue';
          border-radius: 10px;
          width: 100%;
          background: #f0f0f0;
          padding: 15px;
          border: none;
          margin: 0 0 12px;
          color: $color-gray;
          font-size: 14px;
          outline: none;
          appearance: none;
        }
        .select {
          position: relative;
          &::after {
            content: url('../assets/icons/arrow-select.svg');
            position: absolute;
            right: 20px;
            top: 40%;
            transform: translateY(-40%);
          }
        }
        button {
          padding: 10px 60px;
          border-radius: 20px;
          background: $color-black;
          color: $color-white;
          border: none;
          width: 100%;
          font-size: 20px;
          margin-left: auto;
          width: 100%;
          font-family: 'Arvo', serif;
          text-transform: uppercase;
          display: block;
          margin-bottom: 76px;
          transition: 0.3s ease-in-out;
          @include media('>=tablet') {
            margin-bottom: 20px;
            width: auto;
            &:hover {
              background: $color-primary;
              color: $color-black;
            }
          }
          &[disabled] {
            background: $color-lightgray;
            color: $color-gray;
            cursor: not-allowed;
          }
        }
      }
      &__msg {
        max-width: 538px;
        margin: 0px auto;
        margin-left: 90px;
        display: block;
        background: $color-black;
        color: $color-white;
        padding: 10px 60px;
        border-radius: 20px;
        text-align: center;
        font-family: 'Arvo', serif;
        font-size: 18px;
      }
    }
    button {
      outline: none;
      cursor: pointer;
    }
  }
}
</style>
